import { useEffect } from 'react';

const TestErrorPage = () => {
  useEffect(() => {
    throw new Error('Test error page');
  }, []);

  return <></>;
};

export default TestErrorPage;
